import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandStore } from 'zustandGlobalStore'

export const getFrcEventProps = (): Record<string, unknown> => {
  const { frcSettledDate } = useZustandGlobalLocalStore.getState()
  const { isFrcSettled } = useZustandStore.getState()

  return {
    is_frc_settled: isFrcSettled || !!frcSettledDate,
    ...(frcSettledDate && { frc_settled_date: frcSettledDate }),
  }
}
